<template>
  <div class="summary white-box position-relative">
    <TileLoader :loading="loading"/>
    <div>

      <h2>Suivi des RFA</h2>
      <div v-if="period.declarationType == 3">
        <p>
          {{ period.label }} {{ period.year }}
        </p>
        <select :value="concept" @change="updateConcept($event.target.value)">
          <option :value="1">CMEM</option>
          <option :value="2">MME</option>
          <option :value="4">WA</option>
        </select>
      </div>
      <select v-else :value="period.id"
              @change="updatePeriod($event.target.value)"
              class="period-select"
      >
        <option
          v-for="p of detailedPeriods.filter(dp => dp.declarationType == 2 &&
          [2, 4].includes(dp.rfaPaymentFrequency) &&
          dp.year == period.year)"
          :value="p.id"
          :key="p.id"
        >
          {{ p.label }} {{ p.year }}
        </option>
      </select>
    </div>
    <div>
      <div class="chart">
        <canvas :id="'rfa-chart-' + period.id" width="180" height="180"></canvas>
        <span v-if="datas.length > 0" class="total">{{ datas.length }}</span>
      </div>
      <div class="d-flex align-items-center">
        <span class="rfa-status-circle-1 inline"></span>
        {{ datas.filter(row => row.Status == 0).length }}
        à faire ({{ ((datas.filter(row => row.Status == 0).length / datas.length) * 100).toFixed(1) }}%)
      </div>
      <div class="d-flex align-items-center">
        <span class="rfa-status-circle-2 inline"></span>
        {{ datas.filter(row => row.Status == 1).length }}
        facturés ({{ ((datas.filter(row => row.Status == 1).length / datas.length) * 100).toFixed(1) }}%)
      </div>
      <div class="d-flex align-items-center">
        <span class="rfa-status-circle-3 inline"></span>
        {{ datas.filter(row => row.Status == 2).length }}
        payés ({{ ((datas.filter(row => row.Status == 2).length / datas.length) * 100).toFixed(1) }}%)
      </div>
      <div class="d-flex align-items-center">
        <span class="rfa-status-circle-4 inline"></span>
        {{ datas.filter(row => row.Status == 3).length }}
        versés ({{ ((datas.filter(row => row.Status == 3).length / datas.length) * 100).toFixed(1) }}%)
      </div>
    </div>
  </div>
</template>
<script>
import Chart from "chart.js";
import {getFrsRfaState} from "@/utils/frs";
import TileLoader from "./TileLoader.vue";
import store from "@/store/dashboards";
import {getSuiviGrfa} from "@/utils/dashboardGrfa";

export default {
  components: {TileLoader},
  props: {
    pDatas: Array,
    pLoading: Number,
    period: {
      type: Object,
      required: true
    },
    concept: Number,
    detailedPeriods: Array
  },
  data() {
    return {
      datas: [],
      loading: 0,
      store
    }
  },
  mounted() {
    if (this.pDatas) {
      this.datas = this.pDatas;
    }
    if (this.pLoading) {
      this.loading = this.pLoading;
    }
    this.initData();
  },
  computed: {
    storeGlobalView() {
      return this.store.globalView;
    }
  },
  watch: {
    period(newVal) {
      this.initData();
    },
    storeGlobalView() {
      this.initData();
    },
    concept(newVal) {
      this.initData();
    },
    pLoading(newVal) {
      if (newVal) {
        this.loading = 1;
      } else {
        this.loading = 0;
      }
    },
    pDatas(newData) {
      this.datas = newData;
    },
    datas() {
      this.showChart();
    }
  },
  methods: {
    updatePeriod(newPeriodId) {
      let newPeriod = this.detailedPeriods.find(dp => dp.id == newPeriodId);

      if (newPeriod)
        this.$emit('period-change', newPeriod);
    },
    updateConcept(newConceptId) {
      this.$emit('concept-change', parseInt(newConceptId));
    },
    initData() {
      // On n'initialise pas les données si déjà reçues depuis les props par exemple ou si en train de charger à l'extérieur
      if ((this.pDatas && this.pDatas.length > 0) || this.pLoading) return;
      if (!this.period) return;

      this.loading = 1;

      getSuiviGrfa(this.period.id, this.concept, this.storeGlobalView).then(res => {
        this.datas = res;
        this.loading = 0;
      })
    },
    showChart() {
      const canvas = document.getElementById("rfa-chart-" + this.period.id);
      if (this.chart) this.chart.destroy();
      const data = this.datas.reduce((acc, row) => {
        acc[row.Status] += 1;
        return acc;
      }, [0, 0, 0, 0])

      this.chart = new Chart(canvas, {
        type: 'doughnut',
        data: {
          labels: ['A faire', 'Facturés', 'Payés', 'Versés'],
          datasets: [
            {
              data,
              backgroundColor: ['#D32F2F', '#FFC107', '#388E3C', '#50E3C2'],
            },
          ],
        },
        options: {
          legend: {
            display: false
          },
          cutoutPercentage: 80,
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                return " " + data.labels[tooltipItem.index] + " : " + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              }
            }
          },
          animation: {
            duration: 230
          }
        }
      });
    },
  }
}
</script>
<style scoped>
.white-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.white-box p {
  margin: 0;
}

.summary h2 {
  font-size: 20px;
  border-left: 3px solid #A7C13C;
  padding-left: 4px;
}

.summary .chart {
  position: relative;
}

.summary .chart .total {
  position: absolute;
  top: 50%;
  left: 50%;
  line-height: 1;
  transform: translate(-50%, -50%);
  font-size: 48px;
  font-weight: bold;
}

.rfa-status-circle-1,
.rfa-status-circle-2,
.rfa-status-circle-3,
.rfa-status-circle-4 {
  display: block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin: auto;
}

.rfa-status-circle-1.inline,
.rfa-status-circle-2.inline,
.rfa-status-circle-3.inline,
.rfa-status-circle-4.inline {
  display: inline-block;
  margin: 0;
  margin-right: 12px;
  margin-bottom: 6px;
  margin-top: 6px;
}

.rfa-status-circle-1 {
  background-color: #D32F2F;
}

.rfa-status-circle-2 {
  background-color: #FFC107;
}

.rfa-status-circle-3 {
  background-color: #388E3C;
}

.rfa-status-circle-4 {
  background-color: #50E3C2;
}

.rfa-status-container {
  text-align: center;
}

select.period-select {
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboards/RfaChartTile.vue